module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/AlignRight-3f5a6f9803e4f4d1360894f54cbc781b.svg";